import { parse } from 'query-string';
import {
  CASE_METRICS_TOGGLES,
  jobNames,
  metricsPagesHelper
} from './../helpers';
import {
  LOCATION_CHANGE,
  SELECT_JOB
} from './../actions';

const initialState = {
  caseMetricsInfo: {
    toggles: 15,
    buildFilter: '',
    nodes: ['all'],
    image: '',
    givenJob: '',
    dispatcherId: 0,
    jobName: jobNames.CASE_METRICS,
  },
  dropdownPairFirstSelected: '',
  selectedJobs: []
};


const caseMetricsPage = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_JOB:
      if (action.value === undefined) return { ...state };

      const actionAsSelectedJob = {
        value: `${action.value}`,
        index: action.index,
        jobId: action.jobId
      };

      const initSelected = state.selectedJobs.length === 1 ?
        state.selectedJobs[0] && state.selectedJobs[0].value !== action.value ?
          state.selectedJobs :
          [] :
        [];

      return {
        ...state,
        selectedJobs: [...initSelected, actionAsSelectedJob]
      };
    case LOCATION_CHANGE:
      if (!action.payload ||
        !action.payload.search || action.payload.pathname !== '/case-metrics') {
        return state;
      }

      // These are for the main selector:
      // t: build type bit representation
      // f: build filter
      // n: nodes
      // i: selected image name
      // jn: given job number, used to highlight a job coming from another page
      // ji: given job id
      // d: id for selected dispatcher
      // These are for the artifacts selector:
      // g: artifact hunter group
      // The names need to be short because they're part of the URL query.
      const { f, n, i, t, jn, ji, d } = parse(action.payload.search);

      const parseCaseMetricsInfo = (
        toggles,
        buildFilter,
        nodes,
        image,
        givenJob,
        givenJobId,
        dispatcher,
        metricInfo,
      ) => {
        const parsedToggles = parseInt(toggles);
        const parsedGivenJob = parseInt(jn);
        const parsedGivenJobId = parseInt(ji);
        const parsedDispatcher = parseInt(dispatcher);

        return {
          toggles: (parsedToggles < 0) || (parsedToggles > 31) || isNaN(parsedToggles) ?
            metricInfo.toggles :
            parsedToggles,
          buildFilter: buildFilter ? buildFilter : '',
          nodes: nodes ?
            Array.isArray(nodes) ? nodes : [nodes] :
            [],
          image: image ? image : '',
          givenJob: (parsedGivenJob < 0) || isNaN(parsedGivenJob) ?
            metricInfo.givenJob :
            parsedGivenJob,
          givenJobId: (parsedGivenJobId < 0) || isNaN(parsedGivenJobId) ?
            '' : parsedGivenJobId,
          dispatcherId: (parsedDispatcher < 0) || isNaN(parsedDispatcher) ?
            0 :
            parsedDispatcher,
          jobName: metricInfo.jobName
        };
      };

      const parsedInfo =
        parseCaseMetricsInfo(t, f, n, i, jn, ji, d, state.caseMetricsInfo);

      const dropdownPairSelected = metricsPagesHelper.getDropdownPairSelectionOrder(
        state.dropdownPairFirstSelected,
        parsedInfo.dispatcherId,
        parsedInfo.image
      );

      return {
        ...state,
        caseMetricsInfo: parsedInfo,
        dropdownPairFirstSelected: dropdownPairSelected,
        selectedJobs: parsedInfo.givenJob ?
          [{ value: `${parsedInfo.givenJob}`, jobId: `${parsedInfo.givenJobId}` }] :
          []
      };

    default:
      return state;
  }
};

export default caseMetricsPage;

const getCaseMetricsPage = state => state.caseMetricsPage;
export const getCaseMetricsInfo = state =>
  getCaseMetricsPage(state).caseMetricsInfo || initialState.caseMetricsInfo;
export const getCaseMetricsOutliersShown = state =>
  getCaseMetricsInfo(state).toggles & CASE_METRICS_TOGGLES.OUTLIER;
export const getCaseSelectedJobs = state => getCaseMetricsPage(state).selectedJobs;
export const getCaseDropdownFirstSelected = state =>
  getCaseMetricsPage(state).dropdownPairFirstSelected;


// WEBPACK FOOTER //
// src/reducers/caseMetricsPage.js